@if (isLoading) {
  <agmo-loading></agmo-loading>
}

@if (!isLoading && campaign) {
  <div class="container-fluid">
    <campaign-header
      [campaign]="campaign"
      [campaignInfo]="campaignInfo"
      [isLogin]="isLogin"
      [isCampaignEnded]="isCampaignEnded"
      [businessDirectoryInfo]="businessDirectoryInfo"
      [isInvestNowLoading]="isInvestNowLoading"
      (investNow)="investNow()"
      (saveCampaign)="handleSaveCampaign()"
      (onInvestorCountLoaded)="handleInvestorCount($event)"
    ></campaign-header>
    @if (!isCampaignEnded) {
      <campaign-investment-details
        class="md:tw-hidden"
        [campaign]="campaign"
        [isMobile]="true"
        [documents]="documents"
        [isDocumentLoading]="isDocumentLoading"
        [campaignInfo]="campaignInfo"
        [documentsTotal]="documentsTotal"
        (loadMoreDocuments)="handleLoadMoreDocuments()"
      ></campaign-investment-details>
    }
  </div>
  <div id="campaignContent">
    <!-- For Prelive, Live campaigns and for those who previously invested -->
    <ng-container>
      <!-- Tabs & its contents-->
      <nav
        id="tabList"
        class="campaign-tabs navbar navbar-expand-md navbar-light navbar-content tw-sticky tw-top-0 tw-z-[1000] tw-mb-6 tw-bg-white md:tw-mb-12"
      >
        <div class="container-fluid">
          <ul class="navbar-nav mr-auto tw-px-8 md:tw-px-0">
            @for (tab of tabs; track tab) {
              @if (!tab.show || tab.show()) {
                <li class="nav-item d-flex" [class.active]="selectedTab === tab.id">
                  <a
                    class="nav-link tw-select-none"
                    (click)="changeTab(tab.id, $event)"
                    [attr.data-t]="
                      campaign?.campaignStatus === CampaignStatus.PreLive ||
                      campaign?.campaignStatus === CampaignStatus.Live ||
                      campaign?.campaignStatus === CampaignStatus.Cooling
                        ? 'tabClick'
                        : undefined
                    "
                  >
                    {{ tab.name | translate }}
                    @if (tab.val) {
                      <span class="status-badge tab-number">
                        {{ tab.val }}
                      </span>
                    }
                  </a>
                </li>
              }
            }
          </ul>
        </div>
      </nav>
      <div class="campaign-tabs-body container-fluid tw-scroll-mt-32" #tabContent>
        <div class="tw-flex tw-flex-col tw-gap-6 md:tw-flex-row md:tw-gap-6 lg:tw-gap-12">
          <div class="tw-flex-auto">
            <!-- My Investment Tab -->
            @if (selectedTab == 8) {
              <app-investments
                [myInvestment]="myInvestment"
                [campaign]="campaign"
                [campaignStatus]="campaign.campaignStatus"
                (getMyInvestment)="getMyInvestment()"
              >
              </app-investments>
            }
            <!-- Campaign Info Tab -->
            @if (selectedTab == 1) {
              <ng-container>
                <campaign-info-tab
                  [campaign]="campaign"
                  [campaignInfo]="campaignInfo"
                  [campaignStatus]="campaign.campaignStatus"
                  (changeTab)="handleWhatsNewClick($event)"
                ></campaign-info-tab>
              </ng-container>
            }
            <!-- Financial Tab -->
            @if (selectedTab == 2 && canViewFinancialTab) {
              @if (isLogin) {
                @if (isInvitedToInvest || campaign?.isCreator) {
                  <app-financial-list
                    class="tw-mb-10 tw-block"
                    (pageChange)="getFinancialOverview()"
                    [isLoading]="isFinancialOverviewsLoading"
                    [params]="params"
                    [total]="financialOverviewsTotal"
                    [financialOverviews]="financialOverviews"
                    [isPSTX]="false"
                  ></app-financial-list>
                  <app-documents-reports
                    [campaignId]="campaign.id"
                    [campaignSlug]="campaign.slug"
                    [documents]="documents"
                    [isDocumentLoading]="isDocumentLoading"
                    [documentsTotal]="documentsTotal"
                    [myInvestment]="myInvestment"
                    (loadMoreDocuments)="handleLoadMoreDocuments()"
                  ></app-documents-reports>
                } @else {
                  <app-empty-state
                    [title]="'common.inviteOnlyEmptyStateTitle'"
                    [message]="'common.inviteOnlyEmptyStateDescription'"
                    [ctaUrl]="!isIssuer ? campaign?.registrationLinkUrl : null"
                    [ctaText]="!isIssuer ? 'common.registerInterest' : null"
                  >
                  </app-empty-state>
                }
              } @else {
                <app-empty-state
                  [message]="'common.pleaseLoginAsInvestor'"
                  [isRequireLogin]="true"
                  [loginRedirectionQueryString]="'selectedTab=' + selectedTab"
                ></app-empty-state>
              }
            }

            <!-- Updates Tab -->
            @if (selectedTab == 3) {
              @if (isInvitedToInvest || campaign?.isCreator) {
                <app-updates
                  [updates]="updates"
                  [total]="totalNewsUpdates"
                  [params]="updatesParams"
                  [isPublished]="isUpdatesPublished"
                  [isLoading]="isUpdatesLoading"
                  [isCreator]="campaign.isCreator"
                  (getList)="triggerNewUpdates($event)"
                  (deleteItem)="deleteUpdates($event)"
                  (submitForm)="submitUpdates($event)"
                  [campaignStatus]="campaign.campaignStatus"
                ></app-updates>
              } @else {
                <app-empty-state
                  [title]="'common.inviteOnlyEmptyStateTitle'"
                  [message]="'common.inviteOnlyEmptyStateDescription'"
                  [ctaUrl]="!isIssuer ? campaign?.registrationLinkUrl : null"
                  [ctaText]="!isIssuer ? 'common.registerInterest' : null"
                >
                </app-empty-state>
              }
            }
            <!-- Q&A Tab -->
            @if (selectedTab == 4) {
              <ng-container>
                @if (campaignInfo?.foundersUrl) {
                  <div
                    class="tw-mb-6 tw-flex tw-items-center tw-justify-start tw-gap-2 tw-rounded-md tw-bg-info-light tw-p-4 tw-opacity-80"
                  >
                    <div class="pitchin-icon pitchin-icon-calendar"></div>
                    <div
                      class="tw-text-base tw-font-semibold tw-text-black sm:tw-text-xl"
                      [innerHTML]="
                        'campaign.connectWithFoundersBanner'
                          | translate: { foundersUrl: campaignInfo?.foundersUrl }
                          | trustSrc
                      "
                    ></div>
                  </div>
                }
                @if (isInvitedToInvest || campaign?.isCreator) {
                  <app-qa-list
                    [companyName]="campaign.name"
                    [campaignId]="campaign.id"
                    [chatbotUrl]="campaign.chatbotUrl"
                    (onUpdate)="getCampaignInfo()"
                  ></app-qa-list>
                } @else {
                  <app-empty-state
                    [title]="'common.inviteOnlyEmptyStateTitle'"
                    [message]="'common.inviteOnlyEmptyStateDescription'"
                    [ctaUrl]="!isIssuer ? campaign?.registrationLinkUrl : null"
                    [ctaText]="!isIssuer ? 'common.registerInterest' : null"
                  >
                  </app-empty-state>
                }
              </ng-container>
            }
            <!-- Events Tab -->
            @if (selectedTab == 5) {
              @if (isInvitedToInvest || campaign?.isCreator) {
                <app-events
                  [campaignId]="campaign.id"
                  [isCreator]="campaign.isCreator"
                  [campaignStatus]="campaign.campaignStatus"
                  (onUpdate)="getCampaignInfo()"
                ></app-events>
              } @else {
                <app-empty-state
                  [title]="'common.inviteOnlyEmptyStateTitle'"
                  [message]="'common.inviteOnlyEmptyStateDescription'"
                  [ctaUrl]="!isIssuer ? campaign?.registrationLinkUrl : null"
                  [ctaText]="!isIssuer ? 'common.registerInterest' : null"
                >
                </app-empty-state>
              }
            }
            <!-- Investor List -->
            @if (selectedTab == 11 && getTabVisibility(11)) {
              @if (isLogin) {
                @if (isInvitedToInvest || campaign?.isCreator) {
                  <app-campaign-investor-list
                    [campaign]="campaign"
                    (onInvestorListLoaded)="getInvestorCount()"
                  ></app-campaign-investor-list>
                } @else {
                  <app-empty-state
                    [title]="'common.inviteOnlyEmptyStateTitle'"
                    [message]="'common.inviteOnlyEmptyStateDescription'"
                    [ctaUrl]="!isIssuer ? campaign?.registrationLinkUrl : null"
                    [ctaText]="!isIssuer ? 'common.registerInterest' : null"
                  >
                  </app-empty-state>
                }
              } @else {
                <app-empty-state
                  [message]="'common.pleaseLoginAsInvestor'"
                  [isRequireLogin]="true"
                  [loginRedirectionQueryString]="'selectedTab=' + selectedTab"
                ></app-empty-state>
              }
            }

            <!-- [Ended campaign: Campaign Performance & Campaign Business Info] -->
            @if (selectedTab == 12) {
              <campaign-performance [campaign]="campaign"></campaign-performance>

              <div class="tw-mt-10">
                @if (isCampaignEnded) {
                  <campaign-business-info
                    [businessInfo]="businessDirectoryInfo"
                  ></campaign-business-info>
                }
              </div>
              <ng-container>
                @if (canViewCampaignInfoTab12) {
                  <campaign-info-tab
                    [campaign]="campaign"
                    [campaignInfo]="campaignInfo"
                    [campaignStatus]="campaign.campaignStatus"
                    (changeTab)="handleWhatsNewClick($event)"
                  ></campaign-info-tab>
                }
              </ng-container>
            }
          </div>

          <!-- Right panel -->
          @if (!isCampaignEnded && ![8].includes(selectedTab)) {
            <campaign-investment-details
              [campaignInfo]="campaignInfo"
              class="tw-shrink-0 md:tw-w-72"
              [campaign]="campaign"
            ></campaign-investment-details>
          }
        </div>
      </div>

      <campaign-footer [campaign]="campaign"></campaign-footer>
    </ng-container>

    @if (isCampaignEnded) {
      @if (!isMyInvestmentLoading) {
        <!-- For Success/Failed/Rejected campaigns -->
        <ng-container>
          <campaign-histories
            [campaign]="campaign"
            [slug]="campaign?.company?.slug"
          ></campaign-histories>
        </ng-container>

        <ng-container>
          <hr />

          <div class="container-fluid">
            <section class="tw-pb-20 tw-pt-5 lg:tw-pt-10">
              <campaign-business-overview [campaign]="campaign"></campaign-business-overview>
            </section>
          </div>
        </ng-container>
      } @else {
        <div class="container-fluid tw-pb-20">
          <app-skeleton [width]="'60%'" [height]="2.5" [marginBottom]="1.25"></app-skeleton>
          <app-skeleton></app-skeleton>
          <app-skeleton></app-skeleton>
          <app-skeleton [width]="'30%'"></app-skeleton>
        </div>
      }
    }
  </div>
}

@if (notFoundPage) {
  <app-not-found-page></app-not-found-page>
}
